// Single source of truth for personal details.
// Update here — every component reads from this file.

export const profile = {
  name: "Madhu Varsha",
  fullName: "Madhu Varsha Prabhakaran",
  role: "Software Developer",
  location: "Dubai, UAE",
  availability: "Available for opportunities",
  summary:
    "3+ years of experience as a software engineer, shipping production systems end to end across smart contracts, blockchain indexing, backend APIs, and secure authentication, with a growing focus on AI-powered tools.",
  email: "madhuvarsha90809@gmail.com",
  resume: "/assests/Madhu_Varsha_Prabakaran_Resume.pdf",
  socials: [
    { label: "GitHub", url: "https://github.com/MadhuVarshaP" },
    {
      label: "LinkedIn",
      url: "https://www.linkedin.com/in/madhu-varsha-p/",
    },
    { label: "X / Twitter", url: "https://x.com/madhuvarsha_" },
    { label: "Hashnode", url: "https://madhublogs.hashnode.dev/" },
    { label: "Medium", url: "https://medium.com/@madhuvarsha0608" },
    { label: "Linktree", url: "https://linktr.ee/MadhuVarsha" },
  ],
};

// Grouped for the Stack cards on the About page. Each skill lives in
// exactly one group — add new skills to the relevant group, or add a new
// group, and the layout adapts automatically.
//
// Cross-checked against github.com/MadhuVarshaP's repo language stats and
// READMEs (owned repos + verified collaborative commits) on 2026-07-21.
// Left out Rust and Noir seen in a couple of collaborative repos — commit
// count there was too thin (1-2 commits) to confidently claim as a skill.
export const skillGroups = [
  {
    name: "Languages",
    items: ["JavaScript", "TypeScript", "Python", "SQL"],
  },
  {
    name: "Frontend",
    items: ["React", "Next.js", "React Native", "Vue.js", "Tailwind CSS"],
  },
  {
    name: "Backend",
    items: [
      "Node.js",
      "Express",
      "Flask",
      "FastAPI",
      "REST APIs",
      "GraphQL",
      "SQLAlchemy",
      "Celery",
      "Redis",
      "MongoDB",
      "PostgreSQL",
      "pgvector",
      "SQLite",
    ],
  },
  {
    name: "AI & Retrieval",
    items: [
      "RAG",
      "Embeddings",
      "Vector Search (HNSW)",
      "Retrieval Evaluation (Recall@k, MRR)",
    ],
  },
  {
    name: "Security",
    items: ["OAuth 2.0", "JWT", "RBAC", "Zero-Knowledge Proofs"],
  },
  {
    name: "Blockchain",
    items: [
      "Solidity",
      "Smart Contracts (EVM)",
      "Ethers.js",
      "Wagmi",
      "The Graph",
      "IPFS",
      "Semaphore Protocol",
    ],
  },
  {
    name: "Tools",
    items: [
      "Figma",
      "GitHub",
      "Docker",
      "Vercel",
      "Jest",
      "pytest",
      "AI-assisted Dev (Claude, ChatGPT, Copilot)",
    ],
  },
];
